import * as React from 'react';
import { useRouter } from '../contexts/router-context/router-context.js';
import { TrackingProvider } from './tracking-context.js';
import { useTracking } from './use-tracking.js';

function PageViewTracker({
  name,
  children,
  trackingData
}) {
  const {
    pathname
  } = useRouter();
  const rootTrack = useTracking();
  const properties = {
    page: name,
    ...trackingData
  };
  React.useEffect(() => {
    function track() {
      // Ensure Mixpanel super property `page` is kept in sync for downstream events
      window.mixpanel?.register?.({
        page: name
      });
      rootTrack('page_view', properties);
    }
    track();
  }, [pathname]);
  return /*#__PURE__*/React.createElement(TrackingProvider, {
    value: properties
  }, children);
}

export { PageViewTracker };
